import { createSelector } from 'reselect';

import { AppState } from './models/app-state';
import { Contact } from '../common/models/contact';

const userContactState = (state: AppState): Contact => state.user.contact;

export const defaultSearchParamsSelector = createSelector(
    userContactState,
    contact =>
        new URLSearchParams({
            limit: '50',
            page: '1',
        })
);

export const defaultDashboardSearchParamsSelector = createSelector(
    userContactState,
    contact =>
        new URLSearchParams({
            'filter[responsibleContactId]': contact.id.toString(),
            sort: 'number',
            order: 'desc',
            limit: '50',
            page: '1',
        })
);

export const defaultReceiptSearchParamsSelector = createSelector(
    userContactState,
    () =>
        new URLSearchParams({
            sort: 'number',
            order: 'desc',
            limit: '50',
            page: '1',
        })
);
